module.exports = import("https://esm.sh/@tiptap/extension-italic@2.4.0");;